import { render, staticRenderFns } from "./productsLastStatCustom.vue?vue&type=template&id=d80e4666&scoped=true"
import script from "./productsLastStatCustom.vue?vue&type=script&lang=js"
export * from "./productsLastStatCustom.vue?vue&type=script&lang=js"
import style0 from "./productsLastStatCustom.vue?vue&type=style&index=0&id=d80e4666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80e4666",
  null
  
)

export default component.exports